export default "__VITE_ASSET__D1StyhQC__"